
const state = {
  params:{
    areacode : 0,
    province : "",
    orgId:0,
    provincId : 0,
    cityId : 0,
    year : 0,
    TabNavIndex:0
  },
  TabNavIndex:0,
};

export default {
  ...state
};
















// WEBPACK FOOTER //
// ./src/store/state.js